import { observe } from 'redux-observers';
import { tenderHasChangedObserver } from './tenderObservers';
import { userHasChangedObserver } from './userObservers';

export const initStoreObservers = store => {
  observe(store, [tenderHasChangedObserver, userHasChangedObserver]);
};
